<div class="ig-page-header__sticky-actions" [ngClass]="{'ig-page-header__sticky-actions--visible': showStickyActions && !content?.buttonsHidden}" #igPageHeaderStickyActions>
    <!--sticky buttons needs to be enabled-->
    <!--template/projected content has priority over content via @Input-->
    <ng-container *ngIf="content?.stickyButtons?.enabled">

        <!--specific sticky stuff-->
        <ng-container *ngIf="stickyTemplate || !!content?.stickyButtons?.buttons?.length; else defaultAsSticky">
            <div *ngIf="stickyTemplate">
                <ng-container *ngTemplateOutlet="stickyTemplate"></ng-container>
            </div>
            <ul *ngIf="!stickyTemplate && !!content?.stickyButtons?.buttons?.length">
                <li *ngFor="let button of content?.stickyButtons?.buttons">
                    <ig-button [mode]="button.mode" [label]="button.label" [icon]="button.iconCls || ''" [disabled]="!!button.disabled" (onClick)="button?.func()"></ig-button>
                </li>
            </ul>
        </ng-container>

        <!--or take the default content and make it sticky-->
        <ng-template #defaultAsSticky>
            <div *ngIf="buttonsTemplate">
                <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
            </div>
            <ul *ngIf="!buttonsTemplate && !!content?.buttons?.length">
                <li *ngFor="let button of content?.buttons">
                    <ig-button [mode]="button.mode" [label]="button.label" [icon]="button.iconCls || ''" [disabled]="!!button.disabled" (onClick)="button?.func()"></ig-button>
                </li>
            </ul>
        </ng-template>
    </ng-container>
</div>


<div class="ig-page-header p-mb-4">
    <div class="ig-page-header__text">

        <ng-container *ngIf="headlineTemplate || buttonsTemplate || content?.headline || content?.subheadline || !!content?.buttons?.length; else noContent">
            <!--template/projected content has priority over @Input content-->
            <div *ngIf="headlineTemplate">
                <ng-container *ngTemplateOutlet="headlineTemplate"></ng-container>
            </div>
            <ng-container *ngIf="!headlineTemplate">
                <h2 *ngIf="content?.headline" [ngClass]="{'p-mb-1': content?.subheadline}">{{ content?.headline }}</h2>
                <p *ngIf="content?.subheadline">{{ content?.subheadline }}</p>
            </ng-container>
        </ng-container>

        <!--text to show when no content has been provided-->
        <ng-template #noContent>
            <p>Empty component waiting for some delicious content.</p>
        </ng-template>

    </div>


    <div class="ig-page-header__actions" #igPageHeaderActions *ngIf="!!buttonsTemplate || !!content?.buttons?.length">
        <!--template/projected content has priority over @Input content-->
        <div *ngIf="buttonsTemplate">
            <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
        </div>

        <ul *ngIf="!buttonsTemplate && !!content?.buttons?.length" [hidden]="content?.buttonsHidden">
            <li *ngFor="let button of content?.buttons">
                <ig-button [mode]="button.mode" [label]="button.label" [icon]="button.iconCls || ''" [disabled]="!!button.disabled" (onClick)="button?.func()"></ig-button>
            </li>
        </ul>

    </div>
</div>
